import React, { useEffect, useMemo } from "react";
import "./GallinaAmarilla.css";
import { useShoppingContext } from "../../../context/ShoppingContext";
import MortalidadAvesTarjetas from "../ControlAves/MortalidadAvesTarjetas/MortalidadAvesTarjetas";

const GallinaAmarilla = ({ ingestaPorAve, porcentajeMortalidad, src }) => {
  const {
    activeButton,
    aves,
    selectedAve,
    controlAves,
    fetchProduccionHuevos,
    fetchControlAves,
    totalAlimentoConsumido,
    alimentoDisponible,
    costoAlimentacionDiaria,
  } = useShoppingContext();

  // Filtrar el control de aves por el ave seleccionada
  const filteredControlAves = useMemo(() => {
    return selectedAve
      ? controlAves.filter((control) => control.ave_id === selectedAve.id)
      : [];
  }, [controlAves, selectedAve]);

  useEffect(() => {
    fetchProduccionHuevos();
    fetchControlAves();
  }, [fetchProduccionHuevos, fetchControlAves]);

  return (
    <div className="table-button">
      {src ? (
        <img className="left-icon" height={250} src={src} alt="Gallina" />
      ) : null}

      <div className="details">
        {activeButton === "produccionHuevos" && (
          <div className="resumen-produccion"></div>
        )}
        {activeButton === "controlAlimentos" && (
          <div className="resumen-control">
            <div>Ingesta diaria por ave: {ingestaPorAve} gr / ave</div>
            <div>Total de alimento consumido: {totalAlimentoConsumido} kg</div>
            <div>Alimento disponible en stock: {alimentoDisponible} kg</div>
            <div>
              Costo diario de alimentación: S/ {costoAlimentacionDiaria} por ave
            </div>
          </div>
        )}
        {activeButton === "controlAves" && (
          <MortalidadAvesTarjetas
            porcentajeMortalidad={porcentajeMortalidad}
            controlAves={filteredControlAves}
            aves={aves}
          />
        )}
      </div>
    </div>
  );
};

export default GallinaAmarilla;
